import { Helmet } from 'react-helmet-async';

const SITE = 'E-MINA';
const DEFAULT_OG = '/og-default.jpg';

export default function SEO({
  title,
  description,
  url,
  image,
  type = 'website',
  publishedTime,
  author,
  section,
  tags = [],
  jsonLd,
}) {
  if (!title) return null;
  const fullTitle = `${title} — ${SITE}`;
  const safeImage = image || (typeof window !== 'undefined' ? `${window.location.origin}${DEFAULT_OG}` : DEFAULT_OG);
  const safeUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={safeUrl} />
      <meta property="og:image" content={safeImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:locale" content="hr_HR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@eminaeu" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={safeImage} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {author && <meta property="article:author" content={author} />}
      {section && <meta property="article:section" content={section} />}
      {tags.map(tag => <meta property="article:tag" content={tag} key={tag} />)}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
